<template>
    <div class="mx-auto container container--fluid">
        <v-app id="inspire" class>
            <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <template v-if="load==true">
                <v-data-table :headers="headers" :items="exam_list" sort-by="examtype" class="elevation-1" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Question Bank Verification</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            <span style="width: 20px"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <!--<template v-slot:activator="{ on }">
                                    <v-btn color="indigo darken-4" dark class="mb-2" v-on="on">Create New Exam</v-btn>
                                </template>-->
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                       
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                        <v-btn color="primary darken-1" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                        </v-dialog>
                        </v-toolbar>
                    </template>
                     <template v-slot:item.status="{ item }">
                        <span v-if="item.status">
                    <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                    </span>
                        <span v-else>
                     <v-icon  color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                    </span>
                    </template> 
                    <template v-slot:item.details="{ item }">
                        <span v-if="item.details">
                    --
                    </span>
                        <span v-else>
                     <v-btn color="primary darken-1" @click="finddetails(item)" v-model="details_id">Proceed</v-btn>
                    </span>
                    </template> 

                </v-data-table>
            </template>
            <template v-if="question!=null">
            <template>
                <br>
                <center><b>Student Question View</b></center>
            <v-divider></v-divider><br>
            <v-toolbar dense  color="#f79b07">
               Course Code:{{course_code}}
                <v-spacer></v-spacer>
                Course Name:{{course_name}}
            </v-toolbar><br>
            
            <v-card v-for="i in question" :key="i.question" outlined style="border: 1px solid #bdb7b9;">
                <v-card-title></v-card-title>
                
                <v-card-text>
                     <v-card-text style="margin: 8px;" class="pt-0 pb-0">
                        <div>
                        <h6 v-html="i.question">
                            {{i.question}}
                        </h6>
                        <h5 v-for="op in i.option_name" :key="op">{{op}}</h5>
                    </div> 
                     </v-card-text>
  
                </v-card-text> 
            </v-card>        
</template>
</template>




        </v-app>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
           
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            load: false,
            dialog: false,
            exam_list: null,
            details_id:'',
            question:null,
            course_code:'',
            course_name:'',
     
            headers: [{
                text: "Subject",
                value: "name"
            }, {
                text: "Program",
                value: "program"
            },
            {
                text: "Program Type",
                value: "programtype"
			}, 
			 {
                text: "Year",
                value: "year"
            },
             {
                text: "Is verified?",
                value: "status"
            },
            {
                text: "Details",
                value: "details"
            }
            
            
            ],
           
            defaultItem: {
                id: '',
                     
            },
            
        }),

        computed: {
           
        },

        watch: {
            dialog(val) {
                val || this.close();
            }
        },
        mounted() {
            axios
                .post("/Examination/qbverification")
                .then(res => {
                    if (res.data.msg == "200") {
                        this.exam_list = res.data.exam_list;
                        
                        this.load = true;
                        //alert("Success..")
                    } else {}
                })
                .catch(error => {
                    window.console.log(error);
                });
        },

        methods: {
            
            
                showSnackbar(clr, msg) {
                    this.snackbar = true;
                    this.color = clr;
                    this.snackbar_msg = msg;
                },

                close() {
                    this.dialog = false;
                    this.initializeErrorMsgFalse();
                    setTimeout(() => {
                        this.editedItem = Object.assign({}, this.defaultItem);
                        this.editedIndex = -1;
                    }, 300);
                },
        finddetails(item){
            //alert("data::"+item)
            const data = {
                details_id:item
            };
            axios
                .post("/Examination/finddetails", data)
                .then(res => {
                window.console.log(res);
                if (res.data.msg == "200") {
                    this.question = res.data.all_Ques_list;
                    this.course_code=res.data.course_code
                    this.course_name=res.data.course_name
                    //this.orglist.name=res.data.org.name
                    //document.getElementById("ptdiv").style.display = "block";
                    //this.domainpath=res.data.domainpath
                    //alert("success")
                } else {
                    this.message = res.data.msg;
                }
                })
                .catch(error => {
                window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        },
               

                
        }
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    
    .v-icon-size {
        font-size: 20px;
    }
    
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    
    .edit-v-icon:hover {
        color: white;
    }
    .downbtn {
    float: right;
    }
</style>